import { makeStyles } from '@material-ui/core';

export const visualizarVendaStyles = makeStyles({
  dialogPaper: {
    maxWidth: 700,
  },
  cellProdutoServico: {
    padding: '6px 0px 6px 16px',
  },
  historicoDataHora: {
    width: '100%',
    fontWeight: 'bold',
  },
  icon: {
    padding: '5px',
    color: '#43a047',
  },
  iconText: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
});
